export const PAGES_VIEW_TILES = 'tiles';
export const PAGES_VIEW_LINES = 'lines';
export const PAGES_VIEW_GRID = 'grid';
export const PAGES_VIEW_ALL = 'all';

export const TABS_TYPE = 'tabs';
export const PAGE_TYPE = 'page';
export const HIDE_TYPE = 'hide';

export const GRID_VIEW_MINUTE_STEP = 3;
